const defaultComponentStyle: IMultiElementCombineMsg.IComponentStyle = {
  backgroundColor: "transparent",
  paddingBottom: "0px",
  paddingTop: "16px",
  paddingLeft: "16px",
  paddingRight: "16px",
};

const defaultTextStyle: IMultiElementCombineMsg.IPlainTextStyle = {
  // WebkitLineClamp: 999, // 最大行数
  textAlign: "left", // 文字对齐方式
  color: "#1f2227", // 字体颜色
};

// 组件通用样式
export function getDefaultComponentStyle(data: any): {} {
  const componentStyle: IMultiElementCombineMsg.IComponentStyle = {
    ...defaultComponentStyle,
  };

  const {
    background_color,
    bottom_padding,
    top_padding,
    left_padding,
    right_padding,
    paddingTop,
  } = data;

  background_color && (componentStyle.backgroundColor = `#${background_color}`);
  bottom_padding && (componentStyle.paddingBottom = `${bottom_padding}px`);
  // 如果以前的字段中有paddingTop，则以新字段为准，否则使用旧字段
  componentStyle.paddingTop = top_padding
    ? `${top_padding}px`
    : paddingTop
    ? `${paddingTop}px`
    : "16px"; // 新字段覆盖旧字段，默认16px

  left_padding && (componentStyle.paddingLeft = `${left_padding}px`);
  right_padding && (componentStyle.paddingRight = `${right_padding}px`);

  return componentStyle;
}

// 文本通用样式
export function getDefaultTextStyle(data: any): {} {
  const textStyle: IMultiElementCombineMsg.IPlainTextStyle = {
    ...defaultTextStyle,
  };

  const { view_max_line, text_align, text_color } = data;
  const allowedTextAlignValues = ["left", "right", "center"];

  // 如果设置了最大行数，则添加多行溢出显示省略号所需的样式
  if (view_max_line) {
    // 添加以下属性以支持多行文本溢出时显示为省略号
    textStyle.display = "-webkit-box"; // 弹性盒子布局
    textStyle.WebkitBoxOrient = "vertical"; // 垂直排列
    textStyle.WebkitLineClamp = view_max_line; // 最大行数
    textStyle.overflow = "hidden"; // 内容超出宽度时隐藏
  }

  // 文字对齐方式 仅支持 left right center
  if (text_align && allowedTextAlignValues.includes(text_align)) {
    textStyle.textAlign = text_align;
  }

  text_color && (textStyle.color = `#${text_color}`);

  return textStyle;
}
